module.exports = __webpack_public_path__ + "img/palau.13513536.svg";